import "./App.css";
import { React, useState } from "react";
import windows from "./Images/Windows.jpg";
import storefront from "./Images/Storefront.jpg";
import railings from "./Images/Railings.jpg";
import metal from "./Images/MetalPanels.jpg";
import glazing from "./Images/Glazing.jpg";
import curtainWalls from "./Images/CurtainWalls.jpg";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Gallery from "./Pages/Gallery";
import Services from "./Pages/Services";
import Contact from "./Pages/Contact";
import ScrollToTop from "./Components/ScrollToTop";
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";
import ProductPage from "./Pages/ProductPage";

function App() {
  const [nav, setNav] = useState(false);
  const [display, setDisplay] = useState(false);
  const close = () =>{
    if(nav){
      setNav(false);
    }
  }
  let cardClass
  const productsList = [{path:"WindowsDoors", image:windows, title:"Windows & Doors"}, {path:"StoreFronts", image: storefront, title:"Storefronts"}, {path:"Railings", image:railings, title:"Railings"}, {path:"MetalPanels", image:metal, title:"Metal Panels"}, {path:"Glazing", image:glazing, title:"Glazing"}, {path:"CurtainWalls", image:curtainWalls, title:"Curtain Walls"}]
    const products = productsList.map((item, i) => {
        if(i === productsList.length-1 && i%2 === 0){
            cardClass = "card final-odd odds";
        }else if( i%2 === 0){
            cardClass = "card odds";
        }else{
            cardClass = "card evens";
        }
        return(
          <Link className={cardClass} id="product" to={`/Services/${item.path}`} key={i}>
              <img src={item.image} className="background" alt=""/>
              <div className="content">
                  <h1 className="title">{item.title}</h1>
                  <p className="text">
                      Learn More {`>`}
                  </p>
              </div>
          </Link>
          )
      })

  return (
    <Router>
      <ScrollToTop/>
      <Navbar nav={nav} set={setNav} />
      <div className="site" onClick={() => close()}>
        <Switch>
          <Route path="/About">
            <About/>
          </Route>
          <Route path="/Gallery">
            <Gallery display={display} setDisplay={setDisplay} />
          </Route>
          <Route path="/Contact">
            <Contact/>
          </Route>
          <Route path="/Services/WindowsDoors">
            <ProductPage/>
          </Route>
          <Route path="/Services">
            <Services display={display} setDisplay={setDisplay} productsList={productsList}/>
          </Route>
          <Route exact path="/">
            <Home products={products}/>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
